import type { Moment } from "moment";

export enum ThirdServiceCategory {
    Belorder = "belorder",
    CarrePos = "carrepos",
    Deliverect = "deliverect",
    Deliveroo = "deliveroo",
    Devor = "devor",
    Dood = "dood",
    Glovo = "glovo",
    Innovorder = "innovorder",
    IziPass = "izi-pass",
    JustEat = "just-eat",
    Lightspeed = "lightspeed",
    MockCashier = "mock-cashier",
    Otter = "otter",
    Rushour = "rushour",
    Tiller = "tiller",
    Ubereats = "ubereats",
    VitaMojo = "vita-mojo",
    Yokitup = "yokitup",
    Zelty = "zelty",
    ZeltyTag = "zelty-tag",
    ZeShop = "ze-shop",
}

export enum SponsoredAdConfig {
    autoBidding = "auto-bidding",
}

export enum CredentialValidation {
    Unknown = 0,
    Valid = 1,
    Invalid = 2,
}

export interface DeliverectPayload {
    locationId: string;
    channelLinkIds: string[];
}

export interface DeliverooPayload {
    sponsoredAdConfig: SponsoredAdConfig[];
    org_drn_id: string;
    restaurant_drn_id: string;
}

export interface UberEatsPayload {
    directApiActivated: boolean;
    adsManagerActivated: boolean;
    offerFeeActivationDate?: string;
}

export interface IziPassPayload {
    storeIds: number[];
}

export type ServicePayload<T extends ThirdServiceCategory | unknown> =
    T extends ThirdServiceCategory.Deliverect
        ? DeliverectPayload
        : T extends ThirdServiceCategory.Deliveroo
          ? DeliverooPayload
          : T extends ThirdServiceCategory.IziPass
            ? IziPassPayload
            : T extends ThirdServiceCategory.Ubereats
              ? UberEatsPayload
              : never;

export interface PosCredential<T = unknown> {
    rmId: string;
    posId: number;
    remotePosId: string;
    service: ThirdServiceCategory;
    isSetup: boolean;
    isValid: CredentialValidation;
    errorMessage: string;
    remoteName: string;
    virtualBrand?: string;
    payload?: ServicePayload<T>;
    createdDateUTC: Date;
}

export interface VirtualBrand {
    id: string;
    name: string;
}

export type FormCredential =
    | GlovoCredential
    | UberEatsCredential
    | DeliverooCredential
    | InnovorderCredential
    | IziPassCredential
    | SimpleCredential
    | DeliverectCredential;

export interface GlovoCredential {
    email: string;
    password: string;
    shopId: string;
    shopName: string;
    orgaId: number;
}

export interface UberEatsCredential {
    email: string;
    password: string;
    hasMarketingFee: boolean;
    uberEatsFeeStartDate: Moment;
}

export interface DeliverooCredential {
    email: string;
    password: string;
    branchId: string;
}

export interface InnovorderCredential {
    remotePosId: string;
    virtualBrandId: string;
    remoteName: string;
}

export interface IziPassCredential {
    storeIds: number[];
}

export interface SimpleCredential {
    remotePosId: string;
}

export interface DeliverectCredential {
    locationId: string;
    channelLinkIds: string[];
}
